import { css } from '@emotion/css';

export const saveButton = css`
	margin-bottom: 10px;
	width: 143px;

	.saveButton {
		padding: 10px 26px !important;
	}

	.dangerOption {
		color: #dc3545;
	}
`;

export const resolveConflictsButton = css`
	padding: 10px 10px !important;
	margin-bottom: 10px;
	width: 143px;
`;
